var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"bg-primary shadow pt-16 pb-16"},[_c('div',{staticClass:"wrapper text-center"},[_c('h1',{staticClass:"text-3xl font-semibold text-white mx-auto"},[_vm._v(" "+_vm._s(_vm.heading)+" ")]),(_vm.subheading)?_c('h2',{staticClass:"text-white mx-auto"},[_vm._v(_vm._s(_vm.subheading))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }